import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

const HeaderWrapper = styled.div`
  width: 100%;
  position: relative;

  @media only screen and (max-width: 991px) {
    .transparent {
      .navbar_search {
        display: none;
      }
    }
  }

  @media only screen and (max-width: 667px) {
    nav {
      &:not(.transparent) {
        a {
          > h3 {
            display: none;
          }
        }
      }
    }
  }

  .sticky-outer-wrapper {
    nav {
      &.is_transparent {
        > div > div {
          > svg {
            width: 20px;
            position: absolute;
          }

          button {
            color: ${themeGet("color.1", "#ffffff")};
          }

          a {
            img {
              opacity: 0;
            }

            h3 {
              color: ${themeGet("color.1", "#ffffff")};
            }
          }
        }

        .ant-menu:not(.active) {
          li {
            a {
              &.active {
                color: ${themeGet("color.1", "#ffffff")};
              }
              &:hover {
                color: ${themeGet("color.1", "#ffffff")};
              }
            }
          }
        }
      }

      &.transparent {
        > div > div {
          > svg {
            width: 20px;
            position: absolute;
          }

          a {
            img {
              opacity: 0;
            }

            h3 {
              color: ${themeGet("color.1", "#ffffff")};
            }
          }
        }
      }
    }

    &.isHeaderSticky {
      nav {
        &.is_transparent {
          background-color: ${themeGet("color.1", "#ffffff")};
          box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

          > div > div {
            > svg {
              display: none;
            }

            button {
              color: ${themeGet("color.0", "#ffffff")};
              &:hover {
                color: ${themeGet("primary.0", "#008489")};
              }
            }

            a {
              img {
                opacity: 1;
              }

              h3 {
                color: ${themeGet("primary.0", "#008489")};
              }
            }
          }

          .ant-menu {
            li {
              a {
                color: ${themeGet("text.0", "#2C2C2C")};
                &:hover {
                  color: ${themeGet("primary.0", "#008489")};
                }
                &.active {
                  color: ${themeGet("primary.0", "#008489")};
                  border-bottom: 3px solid ${themeGet("primary.0", "#008489")};
                }
              }
            }
          }
        }

        &.transparent {
          background-color: ${themeGet("color.1", "#ffffff")};
          box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

          > div > div {
            > svg {
              display: none;
            }

            a {
              img {
                opacity: 1;
              }

              h3 {
                color: ${themeGet("primary.0", "#008489")};
              }
            }
          }

          .hamburg-btn {
            > span {
              background-color: ${themeGet("text.0", "#2C2C2C")};
            }
          }
        }
      }
    }
  }
`;

export const MobileNavbar = styled.nav`
  display: flex;
  padding: 0.5rem 1rem;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: #fff;

  &.default {
    border-bottom: 1px solid ${themeGet("border.3", "#E6E6E6")};
    background-color: ${themeGet("color.1", "#ffffff")};
  }

  .hamburg-btn {
    height: auto;
    padding: 0.25rem 0.75rem;
    font-size: 1.25rem;
    line-height: 1;
    background-color: transparent;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0.25rem;

    > span {
      font-size: 1.25rem;
      display: inline-block;
      width: 1.5em;
      height: 1.5em;
      vertical-align: middle;
      content: "";
      background: no-repeat 50%;
      background-size: 100% 100%;
    }
  }

  &.transparent {
    position: fixed;
    z-index: 9999;

    .hamburg-btn {
      > span {
        background-color: ${themeGet("color.1", "#ffffff")};
      }
    }
  }
`;

export const LogoArea = styled.a`
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;

  @media only screen and (max-width: 700px) {
    width: 100%;
  }

  > a {
    flex-shrink: 0;
    margin-right: 27px;

    @media only screen and (max-width: 480px) {
      margin-right: 20px;
    }

    img {
      height: 28px;
      max-width: inherit;
    }
  }
`;

export const CloseDrawer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px 15px 12px;

  > button {
    border: 0;
    padding: 0;
    background-color: transparent;
    font-size: 38px;
    line-height: 1;
    height: auto;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    color: ${themeGet("text.1", "#909090")};
    transition: all 0.3s ease;

    &:hover,
    &:focus {
      outline: 0;
      color: ${themeGet("text.0", "#2C2C2C")};
    }
  }
`;

export const AvatarWrapper = styled.div`
  display: flex;
  padding: 25px 35px;
  align-items: center;
  background-color: ${themeGet("color.2", "#F7F7F7")};
`;

export const AvatarImage = styled.div`
  flex-shrink: 0;
  margin-right: 15px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  border-radius: 50%;

  img {
    width: 45px;
    height: 45px;
    overflow: hidden;
    border-radius: 50%;
    object-fit: cover;
  }
`;

export const AvatarInfo = styled.div`
  h3 {
    color: ${themeGet("text.0", "#2C2C2C")};
    font-size: 15px;
    line-height: 18px;
    font-weight: 700;
    margin-bottom: 5px;
  }

  a {
    color: ${themeGet("text.0", "#2C2C2C")};
    font-size: 13px;
    line-height: 16px;
    font-weight: 400;

    &:hover,
    &:focus {
      text-decoration: none;
      outline: 0;
      color: ${themeGet("primary.0", "#008489")};
    }
  }
`;

export const NavbarSearchWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  max-width: 450px;
  width: 100%;
  margin-left: 30px;

  @media only screen and (max-width: 1200px) {
    max-width: 320px;
  }

  @media only screen and (max-width: 480px) {
    padding-right: 15px;
    box-sizing: border-box;
  }

  .map_autocomplete {
    width: 100%;
  }

  input {
    font-size: 17px;
    font-weight: 700;
    padding-left: 15px;
    padding-right: 30px;
    border-radius: 4px;
    color: ${themeGet("text.0", "#2C2C2C")};
    // border: 1px solid ${themeGet("border.0", "#EBEBEB")};
    background-color: ${themeGet("color.2", "#F7F7F7")};
    height: 50px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: all 0.3s ease;
    @media only screen and (max-width: 1200px) {
      height: 48px;
    }

    &::placeholder {
      color: rgb(72, 72, 72);
    }
  }

  > svg {
    position: absolute;
    z-index: 1;
    top: auto;
    right: 15px;
    width: 20px;
    height: 20px;

    @media only screen and (max-width: 480px) {
      right: 25px;
    }
  }
`;

export const LangSwitcher = styled.a`
  color: rgb(128, 128, 128);
  display: flex;
  padding: 0.5rem 0.5rem;
  align-items: center;

  img {
    width: 15px;
    margin-right: 3px;
  }
`;

export const MobileMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  & > a {
    padding: 0.5rem 1rem;
    color: rgb(128, 128, 128);

    &:hover {
      text-decoration: underline;
    }
  }

  .logout {
    margin-right: 10px;
  }

  .avatar-dropdown {
    display: block;
    padding: 0.5rem 0.5rem;

    & > a {
      color: rgb(128, 128, 128);

      &:hover {
        color: rgb(128, 128, 128);
      }
    }

    .avatar-a {
      color: rgb(245, 2, 8);
      margin-right: 0px;
      &:hover {
        text-decoration: underline;
        color: rgb(245, 2, 8);
      }
      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 3px;
        margin-left: 5px;
      }
    }

    .logoutLogo {
      width: 15px;
      margin-right: 3px;
    }

    .signin {
      color: rgb(128, 128, 128);
      margin-right: 15px;
      &:hover {
        text-decoration: underline;
      }

      img {
        vertical-align: middle;
        width: 15px;
        margin-right: 3px;
      }
    }

    .signup {
      margin-right: 15px;
      color: #f50208;
      &:hover {
        color: #f50208;
        text-decoration: underline;
      }

      img {
        vertical-align: middle;
        width: 15px;
        margin-right: 3px;
      }
    }
  }
`;

export default HeaderWrapper;
